import { render, staticRenderFns } from "./HeartSvg.vue?vue&type=template&id=34c7e797&"
import script from "./HeartSvg.vue?vue&type=script&lang=js&"
export * from "./HeartSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports